var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmedCuate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 275,
    height: 285,
    viewBox: "0 0 275 285",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Confirmed-cuate",
    transform: "translate(-42.22 -39.08)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-57",
    transform: "translate(42.22 39.08)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95680",
    "data-name": "Path 95680",
    d: "M60.645,67.367l8.646-.185,4.389-.072h4.705v.3l.04,7.374v.329h-.329l-8.705-.079c-2.913,0-5.819-.072-8.725-.112H60.48v-.178c0-1.252.059-2.491.086-3.723Zm0,0,.092,3.73c0,1.226.072,2.438.086,3.644l-.178-.178c2.906,0,5.812-.105,8.725-.105l8.725-.046-.329.329.033-7.374.3.3c-1.443,0-2.873,0-4.316-.04l-4.336-.072Z",
    transform: "translate(-48.447 -48.639)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95681",
    "data-name": "Path 95681",
    d: "M75.4,53.257l8.646-.185L88.439,53h4.705v.3l.04,7.374V61h-.316l-8.738-.092c-2.913,0-5.819-.072-8.725-.112H75.22v-.178c0-1.252.059-2.491.086-3.723Zm0,0,.092,3.73c0,1.226.072,2.438.086,3.644l-.178-.178c2.906,0,5.812-.105,8.725-.105l8.738-.046-.329.329V53.257l.3.3c-1.437,0-2.873,0-4.316-.04l-4.336-.072Z",
    transform: "translate(-53.474 -43.827)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95682",
    "data-name": "Path 95682",
    d: "M101.085,197.007l8.646-.185,4.389-.072c1.47-.033,2.946,0,4.415-.04h.29v.3l.04,7.374v.329h-.329l-8.725-.046c-2.913,0-5.819-.072-8.725-.105H100.9v-.178c0-1.252.059-2.5.086-3.73Zm0,0,.092,3.723c0,1.226.072,2.445.086,3.651l-.178-.185c2.906,0,5.812-.105,8.725-.105l8.725-.04-.329.329v-7.374l.3.29h-4.316l-4.336-.072Z",
    transform: "translate(-62.231 -92.836)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95683",
    "data-name": "Path 95683",
    d: "M115.9,182.9l8.646-.185,4.389-.072c1.47,0,2.946,0,4.415-.04h.29v.3l.04,7.374v.329h-.329l-8.725-.046c-2.913,0-5.819-.072-8.725-.105h-.185v-.178c0-1.252.059-2.5.092-3.73Zm0,0L116,186.62c0,1.226.072,2.445.086,3.651l-.178-.158c2.906-.033,5.812-.1,8.725-.105l8.725-.04-.329.329v-7.374l.3.29c-1.437,0-2.873,0-4.316-.033l-4.336-.072Z",
    transform: "translate(-67.391 -88.024)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95684",
    "data-name": "Path 95684",
    d: "M45.891,53.257l8.652-.185L58.9,53H63.6v.3l.033,7.374V61H63.3l-8.718-.092c-2.906,0-5.812-.072-8.725-.112H45.68v-.178c0-1.252.059-2.491.086-3.723Zm0,0,.1,3.73c0,1.226.072,2.438.086,3.644l-.185-.178c2.913,0,5.819-.105,8.725-.105l8.725-.046-.329.329.013-7.374.29.3c-1.437,0-2.867,0-4.31-.04l-4.336-.072Z",
    transform: "translate(-43.4 -43.827)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95685",
    "data-name": "Path 95685",
    d: "M430.069,292.423l-8.646.185-4.389.079c-1.469,0-2.939,0-4.415.033h-.29v-.3l-.039-7.367v-.336h.329l8.725.04c2.913,0,5.819.072,8.725.105h.185v.178c0,1.245-.059,2.491-.086,3.723Zm0,0-.092-3.723c0-1.226-.073-2.438-.086-3.644l.178.178c-2.906.033-5.812.105-8.725.105l-8.725.04.329-.323-.033,7.367-.3-.29h4.316l4.336.079Z",
    transform: "translate(-168.987 -122.849)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95686",
    "data-name": "Path 95686",
    d: "M444.849,306.533l-8.652.185-4.389.079c-1.47,0-2.939,0-4.409.033h-.3v-.3l-.033-7.374v-.329h.336l8.725.04c2.906,0,5.812.072,8.725.105h.178v.171c0,1.252-.059,2.5-.086,3.73Zm0,0-.1-3.723c0-1.226-.073-2.438-.086-3.651l.185.185c-2.913.033-5.819.105-8.725.105l-8.725.04.329-.329-.046,7.374-.29-.29c1.437,0,2.867,0,4.31.033l4.336.079Z",
    transform: "translate(-174.027 -127.661)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95687",
    "data-name": "Path 95687",
    d: "M78.229,306.533l-8.646.185-4.389.079c-1.47,0-2.946,0-4.415.033h-.29v-.3l-.04-7.374v-.329h.362l8.725.04c2.913,0,5.819.072,8.725.105h.185v.171c0,1.252-.059,2.5-.092,3.73Zm0,0-.092-3.723c0-1.226-.072-2.438-.086-3.651l.178.185c-2.906.033-5.812.105-8.725.105l-8.692.04.329-.329-.033,7.374-.3-.29c1.437,0,2.873,0,4.316.033l4.336.079Z",
    transform: "translate(-48.437 -127.661)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95688",
    "data-name": "Path 95688",
    d: "M412.588,53.257l8.652-.185L425.629,53h4.705v.3l.033,7.374V61h-.329l-8.725-.092c-2.906,0-5.819-.072-8.725-.112h-.178v-.178c0-1.252.053-2.491.086-3.723Zm0,0,.092,3.73c.033,1.226.079,2.438.086,3.644l-.178-.178c2.906,0,5.819-.105,8.725-.105l8.725-.046-.329.329.04-7.374.29.3c-1.437,0-2.873,0-4.31-.04l-4.362-.072Z",
    transform: "translate(-169.028 -43.827)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95689",
    "data-name": "Path 95689",
    d: "M405.266,162.373H317.53V39.85h87.736Zm-85.133-2.6h82.53V42.453h-82.53Z",
    transform: "translate(-136.671 -39.343)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6892",
    "data-name": "Rectangle 6892",
    width: 2.603,
    height: 117.937,
    transform: "translate(223.422 3.789)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6893",
    "data-name": "Rectangle 6893",
    width: 92.461,
    height: 3.624,
    transform: "translate(178.5 5.773)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6894",
    "data-name": "Rectangle 6894",
    width: 92.461,
    height: 3.624,
    transform: "translate(178.5 9.852)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6895",
    "data-name": "Rectangle 6895",
    width: 92.461,
    height: 3.624,
    transform: "translate(178.5 13.924)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6896",
    "data-name": "Rectangle 6896",
    width: 92.461,
    height: 3.624,
    transform: "translate(178.5 18.003)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6897",
    "data-name": "Rectangle 6897",
    width: 92.461,
    height: 3.624,
    transform: "translate(178.5 22.082)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6898",
    "data-name": "Rectangle 6898",
    width: 92.461,
    height: 3.624,
    transform: "translate(178.5 26.161)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6899",
    "data-name": "Rectangle 6899",
    width: 92.461,
    height: 3.624,
    transform: "translate(178.5 30.24)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6900",
    "data-name": "Rectangle 6900",
    width: 92.461,
    height: 3.624,
    transform: "translate(178.5 34.319)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6901",
    "data-name": "Rectangle 6901",
    width: 92.461,
    height: 3.624,
    transform: "translate(178.5 38.399)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6902",
    "data-name": "Rectangle 6902",
    width: 0.652,
    height: 70.543,
    transform: "translate(262.572 5.035)",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95690",
    "data-name": "Path 95690",
    d: "M442.583,156.651H440.27l.58-3.321H442Z",
    transform: "translate(-178.529 -78.042)",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6903",
    "data-name": "Rectangle 6903",
    width: 0.652,
    height: 88.336,
    transform: "translate(264.918 5.035)",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95691",
    "data-name": "Path 95691",
    d: "M446.143,182.761H443.83l.58-3.321h1.153Z",
    transform: "translate(-179.743 -86.946)",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6904",
    "data-name": "Rectangle 6904",
    width: 100.54,
    height: 7.585,
    transform: "translate(174.46)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6905",
    "data-name": "Rectangle 6905",
    width: 73.687,
    height: 4.376,
    transform: "translate(0 43.492)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6906",
    "data-name": "Rectangle 6906",
    width: 4.376,
    height: 14.471,
    transform: "translate(5.595 47.868)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6907",
    "data-name": "Rectangle 6907",
    width: 4.376,
    height: 4.474,
    transform: "translate(5.595 47.868)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6908",
    "data-name": "Rectangle 6908",
    width: 4.376,
    height: 14.471,
    transform: "translate(63.584 47.868)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6909",
    "data-name": "Rectangle 6909",
    width: 4.376,
    height: 4.474,
    transform: "translate(63.584 47.868)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6910",
    "data-name": "Rectangle 6910",
    width: 27.888,
    height: 7.025,
    transform: "translate(16.613 15.605) rotate(90)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6911",
    "data-name": "Rectangle 6911",
    width: 3.064,
    height: 7.025,
    transform: "translate(16.613 14.122) rotate(90)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6912",
    "data-name": "Rectangle 6912",
    width: 1.14,
    height: 7.025,
    transform: "translate(16.613 21.107) rotate(90)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6913",
    "data-name": "Rectangle 6913",
    width: 3.064,
    height: 7.895,
    transform: "translate(17.489 36.771) rotate(90)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6914",
    "data-name": "Rectangle 6914",
    width: 32.527,
    height: 4.909,
    transform: "translate(21.516 10.965) rotate(90)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6915",
    "data-name": "Rectangle 6915",
    width: 12.514,
    height: 2.946,
    transform: "translate(20.514 14.023) rotate(90)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6916",
    "data-name": "Rectangle 6916",
    width: 32.527,
    height: 4.909,
    transform: "matrix(0.711, 0.703, -0.703, 0.711, 33.291, 17.144)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6917",
    "data-name": "Rectangle 6917",
    width: 12.514,
    height: 2.946,
    transform: "matrix(0.711, 0.703, -0.703, 0.711, 41.426, 26.532)",
    fill: "#dbdbdb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6918",
    "data-name": "Rectangle 6918",
    width: 24.705,
    height: 8.336,
    transform: "translate(29.852 18.794) rotate(90)",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6919",
    "data-name": "Rectangle 6919",
    width: 2.3,
    height: 8.336,
    transform: "translate(29.852 38.576) rotate(90)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6920",
    "data-name": "Rectangle 6920",
    width: 0.896,
    height: 8.336,
    transform: "translate(29.852 36.171) rotate(90)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6921",
    "data-name": "Rectangle 6921",
    width: 23.222,
    height: 5.759,
    transform: "translate(9.588 20.283) rotate(90)",
    fill: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6922",
    "data-name": "Rectangle 6922",
    width: 2.161,
    height: 5.759,
    transform: "translate(9.588 38.873) rotate(90)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6923",
    "data-name": "Rectangle 6923",
    width: 2.161,
    height: 5.759,
    transform: "translate(9.588 25.061) rotate(90)",
    fill: "#c7c7c7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6924",
    "data-name": "Rectangle 6924",
    width: 0.837,
    height: 5.759,
    transform: "translate(9.588 28.712) rotate(90)",
    fill: "#c7c7c7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-57",
    transform: "translate(46.477 290.209)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95692",
    "data-name": "Path 95692",
    d: "M313.446,437.826c0,9.351-59.274,16.936-132.383,16.936S48.68,447.177,48.68,437.826s59.274-16.936,132.383-16.936S313.446,428.475,313.446,437.826Z",
    transform: "translate(-48.68 -420.89)",
    fill: "#ebebeb"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-57",
    transform: "translate(251.25 173.123)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95693",
    "data-name": "Path 95693",
    d: "M386.547,314.523s-10.932-2.478-16.922-8-9.344-15.413-9.344-15.413a93.986,93.986,0,0,1,12.264,3.222,20.672,20.672,0,0,1,3.71,5.272,24.928,24.928,0,0,0,0-3.75,16.587,16.587,0,0,1,3.895,2.359C385.137,302.537,386.547,314.523,386.547,314.523Z",
    transform: "translate(-360.28 -259.407)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95694",
    "data-name": "Path 95694",
    d: "M368.3,296.732c-1.489-1.028-3-2.023-4.488-3.064-.092-.059,0-.2.086-.145,2.82,1.68,5.595,3.479,8.283,5.364q1.4.988,2.768,2.036l-.191-.323c-.329-.547-.659-1.087-1.021-1.628a22.99,22.99,0,0,0-2.32-3.1c-.033-.033,0-.086.053-.053.85.982,1.7,1.977,2.478,3,.369.494.712,1.008,1.041,1.529.171.277.336.547.488.83l.165.277c1.417,1.114,2.794,2.273,4.105,3.493q1.219,1.133,2.353,2.346c-.428-1.318-.8-2.636-1.285-3.954,0-.046.059-.066.072,0,.474,1.364,1,2.741,1.364,4.145.837.9,1.641,1.839,2.392,2.82l-.04-.178c-.125-.521-.25-1.035-.389-1.542-.264-.988-.56-1.977-.89-2.946a17.133,17.133,0,0,0-2.939-5.542c-.033-.04,0-.092.053-.053a21.384,21.384,0,0,1,4.191,8.745c.119.461.224.929.329,1.4.059.25.125.5.165.758.33.448.659.9.969,1.357a47.836,47.836,0,0,1,4.613,9.074,105.371,105.371,0,0,1,3.532,10.9.059.059,0,0,1-.112,0c-2.142-6.4-4.323-12.89-7.987-18.6a42.146,42.146,0,0,0-2.5-3.5,20.632,20.632,0,0,1-5.318-1.054A23.927,23.927,0,0,1,373,306.544a33,33,0,0,1-2.735-2.063.04.04,0,1,1,.046-.059,21.86,21.86,0,0,0,5.015,3.038,27.132,27.132,0,0,0,5.516,1.845c.8.178,1.628.31,2.445.422a45.951,45.951,0,0,0-3.222-3.572c-.369-.369-.751-.725-1.133-1.081a25.813,25.813,0,0,0-4.04-2.313c-1.792-.87-3.558-1.786-5.331-2.689-1-.507-1.977-1.028-3-1.522-.046,0,0-.079.039-.059,1.792.87,3.618,1.68,5.43,2.511s3.44,1.568,5.074,2.484l.211.125c-1.483-1.318-3.018-2.517-4.613-3.7C371.263,298.841,369.794,297.786,368.3,296.732Z",
    transform: "translate(-361.471 -260.225)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95695",
    "data-name": "Path 95695",
    d: "M371.565,306.99c.89.389,1.792.731,2.675,1.147s1.759.916,2.636,1.423a.034.034,0,1,1-.033.059c-.87-.415-1.753-.8-2.636-1.239s-1.759-.923-2.669-1.318C371.5,306.99,371.519,306.944,371.565,306.99Z",
    transform: "translate(-364.112 -264.816)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95696",
    "data-name": "Path 95696",
    d: "M439.323,243a15.631,15.631,0,0,0-3.295,9.081c-.033.982.119,2.353.237,3.954a25.983,25.983,0,0,0-7.137,6.1,12.9,12.9,0,0,1,7.209-1.727,22.292,22.292,0,0,1-.415,3.295,12.256,12.256,0,0,0-4.613.916,10.379,10.379,0,0,1,4.178.83c-1.977,6.2-7.736,12.573-23.723,15.275a33.607,33.607,0,0,1,2.834-22.511C419.4,248.773,439.323,243,439.323,243Z",
    transform: "translate(-377.563 -243)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95697",
    "data-name": "Path 95697",
    d: "M403.5,309.45q.415-3.954,1.035-7.908a158.157,158.157,0,0,1,3.222-15.657,63.038,63.038,0,0,1,2.313-7.137,10.441,10.441,0,0,1-.059-1.278v-1.542c0-1.021.059-2.043.145-3.064a37.033,37.033,0,0,1,.982-6c.3-1.14.659-2.26.969-3.387a.04.04,0,0,1,.072,0,43.976,43.976,0,0,0-1.186,5.99,57.224,57.224,0,0,0-.534,6c0,.547-.033,1.1-.033,1.647v.705a52.244,52.244,0,0,1,2.7-5.575,68.188,68.188,0,0,1,5.476-8.191,3.426,3.426,0,0,1,.132-.9c.072-.356.152-.712.231-1.074.165-.725.349-1.456.547-2.175.4-1.45.923-2.853,1.377-4.283a.04.04,0,0,1,.072,0c-.422,1.417-.705,2.886-1.028,4.329-.165.712-.316,1.423-.474,2.142-.079.356-.158.712-.231,1.068v.086q.969-1.226,1.977-2.412c3.051-3.585,6.4-6.893,9.773-10.168.415-.409.837-.8,1.259-1.2,0,0,.086,0,.053.059-3.222,3.361-6.392,6.755-9.4,10.313-.718.85-1.417,1.707-2.109,2.57l1.094-.725c.929-.606,1.871-1.2,2.84-1.74s1.977-1.081,2.946-1.575,2.122-.923,3.117-1.5c.04,0,.079.046.033.066a22.946,22.946,0,0,0-2.919,1.615c-.975.58-1.944,1.16-2.9,1.766s-1.885,1.186-2.82,1.792c-.778.507-1.542,1.061-2.353,1.522a76.717,76.717,0,0,0-5.127,7.46,55.45,55.45,0,0,0-2.636,5.028l.573-.25,1.469-.659c.936-.415,1.885-.824,2.827-1.232,1.792-.784,3.618-1.5,5.377-2.353a24.915,24.915,0,0,0,2.873-1.595c.04,0,.073,0,.033.066a64.8,64.8,0,0,1-10.583,5.456l-1.575.7c-.435.191-.87.4-1.318.573a55.952,55.952,0,0,0-2.708,7.413,151.639,151.639,0,0,0-3.479,15.473c-.916,5.226-1.535,10.484-2.016,15.769-.059.659-.119,1.318-.2,1.977a.211.211,0,0,1-.415,0C402.969,314.8,403.213,312.119,403.5,309.45Z",
    transform: "translate(-374.818 -245.206)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95698",
    "data-name": "Path 95698",
    d: "M418.263,270.95c.29-1.628.725-3.216,1.16-4.811,0-.046.086,0,.072,0-.4,1.562-.692,3.156-.988,4.738s-.56,3.242-.791,4.87c0,0-.046.033-.046,0A42.47,42.47,0,0,1,418.263,270.95Z",
    transform: "translate(-379.851 -250.884)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95699",
    "data-name": "Path 95699",
    d: "M428.993,278.23a29.459,29.459,0,0,1,3.479-1.977c.58-.3,1.173-.586,1.759-.87s1.245-.54,1.852-.844c.04,0,.072.04,0,.059-.586.3-1.14.659-1.713.962l-1.779.975c-1.166.626-2.32,1.318-3.545,1.832a.092.092,0,0,1-.053-.138Z",
    transform: "translate(-383.708 -253.756)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95700",
    "data-name": "Path 95700",
    d: "M389.1,283.55s-10.115-2.418-14.761-9.226c-4.435-6.478-5.871-17.529-5.983-18.5.178.9,2.267,10.544,9.153,15.051C382.792,274.337,387.892,277.171,389.1,283.55Z",
    transform: "translate(-363.035 -247.372)",
    fill: "#263238",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95701",
    "data-name": "Path 95701",
    d: "M385.639,271.365a12.916,12.916,0,0,1,3.73,6.142h-.033a15.024,15.024,0,0,0-3.743-6.1C385.553,271.391,385.606,271.332,385.639,271.365Z",
    transform: "translate(-368.907 -252.67)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95702",
    "data-name": "Path 95702",
    d: "M389.1,283.516s-10.115-2.418-14.761-9.226c-4.435-6.478-5.871-17.529-5.983-18.5a.229.229,0,0,1,0-.066s4.85,6.9,9.951,8.659S390.566,272.241,389.1,283.516Z",
    transform: "translate(-363.034 -247.338)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95703",
    "data-name": "Path 95703",
    d: "M371.033,261.511a41.283,41.283,0,0,0,3.13,5.351,21.345,21.345,0,0,0,4.158,4.283c1.377,1.094,2.827,2.082,4.217,3.15v-.053c-.264-.382-.54-.764-.83-1.127-.58-.745-1.212-1.443-1.852-2.135-1.252-1.364-2.537-2.7-3.664-4.178a15.259,15.259,0,0,1-1.621-2.636c0-.046.046-.066.066,0,1.641,3.42,4.923,5.608,7.249,8.494a15.786,15.786,0,0,1,.929,1.278,5.455,5.455,0,0,1,.586,1.028,21.38,21.38,0,0,1,3.453,3.493,13.842,13.842,0,0,0-.409-1.977,9.746,9.746,0,0,0-1.074-2.563c0-.04.04-.086.066-.04a12.387,12.387,0,0,1,1.18,2.544,8.844,8.844,0,0,1,.369,2.181h0a20.152,20.152,0,0,1,1.371,2.129c-.046-.217-.086-.435-.125-.659-.2-1.008-.422-2.016-.659-3.012a18.136,18.136,0,0,0-2.432-5.7c-.033-.04,0-.079.059-.04a21.687,21.687,0,0,1,2.7,5.575c.323,1,.58,1.977.811,3.025.112.494.211,1,.3,1.5.053.257.105.527.152.791a36.766,36.766,0,0,1,2.333,6.86,101.02,101.02,0,0,1,2.155,12.791,106.311,106.311,0,0,1,.7,13.581c0,.573-.046,1.14-.072,1.707a.119.119,0,1,1-.237,0c-.1-2.247-.158-4.494-.29-6.735s-.329-4.481-.567-6.722a120.125,120.125,0,0,0-2.109-13.081,33.755,33.755,0,0,0-3.908-10.662,20.032,20.032,0,0,0-3.651-4.343c-1.417-1.272-2.965-2.386-4.461-3.565a24.425,24.425,0,0,1-4.1-3.954,32.382,32.382,0,0,1-3.216-5.219l-.725-1.371C370.947,261.511,370.993,261.471,371.033,261.511Z",
    transform: "translate(-363.929 -249.306)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95704",
    "data-name": "Path 95704",
    d: "M373.671,263.767a35.34,35.34,0,0,0,2.254,3.954s0,.059-.046,0a27.291,27.291,0,0,1-2.28-3.954C373.578,263.747,373.651,263.721,373.671,263.767Z",
    transform: "translate(-364.821 -250.073)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95705",
    "data-name": "Path 95705",
    d: "M441.959,291.11s.165,14.379-8.435,18.524-13.18.7-19.044,2.089h0c.224-.343,4.4-6.339,11.025-7.987C432.332,302.029,439.864,297.1,441.959,291.11Z",
    transform: "translate(-378.764 -259.407)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95706",
    "data-name": "Path 95706",
    d: "M441.959,291.11s.165,14.379-8.435,18.524-13.18.7-19.044,2.089h0a32.5,32.5,0,0,1,9.779-2.893C429.683,308.171,440.035,304.645,441.959,291.11Z",
    transform: "translate(-378.764 -259.407)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95707",
    "data-name": "Path 95707",
    d: "M410.162,316.527a14.234,14.234,0,0,1,3.42-2.32c.178-.086.369-.158.56-.237a3.385,3.385,0,0,1,.283-.329c.264-.27.527-.527.811-.771a12.407,12.407,0,0,1,1.733-1.245c1.423-.837,2.985-1.423,4.442-2.2.039,0,.079.04.033.066-.718.369-1.417.784-2.115,1.193s-1.377.778-2.043,1.206a15.221,15.221,0,0,0-1.7,1.272c-.152.132-.3.277-.441.422a23.3,23.3,0,0,1,2.906-.771c1.575-.316,3.163-.54,4.738-.876a22.81,22.81,0,0,0,2.28-.613c.712-.58,1.423-1.147,2.1-1.773a17.535,17.535,0,0,0,2.221-2.465c0-.033.092,0,.059.04a26.619,26.619,0,0,1-3.519,3.895c.369-.145.732-.3,1.094-.461a17.68,17.68,0,0,0,7.328-6.1c0-.04.092,0,.066.04a20.1,20.1,0,0,1-5.931,5.694,17.858,17.858,0,0,1-3.743,1.773,35.094,35.094,0,0,1-4.652,1.1,32.451,32.451,0,0,0-4.554,1.081,13.777,13.777,0,0,0-3.822,2.01,17.91,17.91,0,0,0-5.153,6.385,32.156,32.156,0,0,0-2.84,10.544c0,.152-.25.152-.244,0C403.882,327.012,405.5,320.719,410.162,316.527Z",
    transform: "translate(-375.012 -263.954)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95708",
    "data-name": "Path 95708",
    d: "M428.756,313.923a4.916,4.916,0,0,1,1.766-1.6,6.537,6.537,0,0,0,2.1-1.74c0-.04.092,0,.059.04a7.177,7.177,0,0,1-1.852,1.661,6.55,6.55,0,0,0-2.023,1.674C428.783,313.988,428.73,313.955,428.756,313.923Z",
    transform: "translate(-383.63 -266.041)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95709",
    "data-name": "Path 95709",
    d: "M410.852,338.88l-.389,7.908-1.2,24.151H391.228l-1.2-24.151-.389-7.908Z",
    transform: "translate(-370.292 -275.697)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95710",
    "data-name": "Path 95710",
    d: "M410.852,338.88l-.389,7.908H390.029l-.389-7.908Z",
    transform: "translate(-370.292 -275.697)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6925",
    "data-name": "Rectangle 6925",
    width: 23.743,
    height: 7.545,
    transform: "translate(18.082 59.881)",
    fill: "#37474f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-57",
    transform: "translate(42.22 267.896)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95711",
    "data-name": "Path 95711",
    d: "M42.22,387.359l34.157-.158,34.163-.059,68.32-.112,68.32.112,34.163.059,34.157.158-34.157.165-34.163.059-68.32.105-68.32-.112-34.163-.053Z",
    transform: "translate(-42.22 -387.03)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-57",
    transform: "translate(96.354 48.148)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6926",
    "data-name": "Rectangle 6926",
    width: 246.186,
    height: 165.027,
    rx: 12.89,
    transform: "translate(165.027 0) rotate(90)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6927",
    "data-name": "Rectangle 6927",
    width: 150.912,
    height: 211.808,
    transform: "translate(7.15 17.265)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6928",
    "data-name": "Rectangle 6928",
    width: 2.563,
    height: 35.914,
    rx: 1.25,
    transform: "translate(100.461 8.738) rotate(90)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1012",
    "data-name": "Ellipse 1012",
    cx: 4.646,
    cy: 4.646,
    r: 4.646,
    transform: "translate(77.865 232.77)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6929",
    "data-name": "Rectangle 6929",
    width: 104.408,
    height: 1.47,
    transform: "translate(30.405 46.418)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6930",
    "data-name": "Rectangle 6930",
    width: 104.408,
    height: 1.47,
    transform: "translate(30.405 50.88)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6931",
    "data-name": "Rectangle 6931",
    width: 104.408,
    height: 1.47,
    transform: "translate(30.405 189.477)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6932",
    "data-name": "Rectangle 6932",
    width: 104.408,
    height: 1.47,
    transform: "translate(30.405 194.028)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1013",
    "data-name": "Ellipse 1013",
    cx: 4.824,
    cy: 4.824,
    r: 4.824,
    transform: "translate(50.965 200.104)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95712",
    "data-name": "Path 95712",
    d: "M208.083,364.861l-2.873-2.906.969-.956,1.674,1.7,3.493-5.47,1.14.731Z",
    transform: "translate(-152.215 -157.119)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95713",
    "data-name": "Path 95713",
    d: "M227.779,363.03a3.031,3.031,0,0,1,.185-1.015,2.709,2.709,0,0,1,.547-.9,2.636,2.636,0,0,1,2.036-.89,2.537,2.537,0,0,1,1.318.343,2.154,2.154,0,0,1,.837.883l-.824.6a1.384,1.384,0,0,0-.27-.4,1.524,1.524,0,0,0-.336-.257,1.666,1.666,0,0,0-.382-.138,1.976,1.976,0,0,0-.389-.039,1.457,1.457,0,0,0-.712.165,1.53,1.53,0,0,0-.507.428,1.905,1.905,0,0,0-.3.6,2.194,2.194,0,0,0,0,1.384,1.872,1.872,0,0,0,.336.606,1.786,1.786,0,0,0,.521.422,1.443,1.443,0,0,0,.659.158,1.72,1.72,0,0,0,.4-.053,1.384,1.384,0,0,0,.389-.145,1.641,1.641,0,0,0,.343-.264,1.364,1.364,0,0,0,.257-.4l.89.514a1.694,1.694,0,0,1-.382.56,2.286,2.286,0,0,1-.56.4,2.879,2.879,0,0,1-1.364.343,2.457,2.457,0,0,1-1.1-.25,2.832,2.832,0,0,1-.857-.659,3.063,3.063,0,0,1-.56-.923A2.807,2.807,0,0,1,227.779,363.03Z",
    transform: "translate(-159.911 -158.142)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95714",
    "data-name": "Path 95714",
    d: "M238.665,365.9a2.517,2.517,0,0,1-1.12-.244,2.827,2.827,0,0,1-1.417-1.555,2.873,2.873,0,0,1-.2-1.048,2.834,2.834,0,0,1,.211-1.074,2.96,2.96,0,0,1,.573-.909,2.9,2.9,0,0,1,.876-.659,2.635,2.635,0,0,1,1.1-.231,2.379,2.379,0,0,1,1.107.25,2.741,2.741,0,0,1,.863.659,3.011,3.011,0,0,1,.586.949,2.887,2.887,0,0,1,.2,1.041,2.834,2.834,0,0,1-.211,1.074,2.794,2.794,0,0,1-.567.9,2.756,2.756,0,0,1-.87.619A2.557,2.557,0,0,1,238.665,365.9Zm-1.628-2.847a2.319,2.319,0,0,0,.112.705,1.937,1.937,0,0,0,.316.6,1.759,1.759,0,0,0,.514.422,1.483,1.483,0,0,0,.692.152,1.522,1.522,0,0,0,.705-.158,1.686,1.686,0,0,0,.514-.428,2.049,2.049,0,0,0,.316-.606,2.438,2.438,0,0,0,.105-.659,2.115,2.115,0,0,0-.119-.705,1.877,1.877,0,0,0-.323-.6,1.43,1.43,0,0,0-.514-.415,1.457,1.457,0,0,0-.659-.152,1.5,1.5,0,0,0-.7.158,1.423,1.423,0,0,0-.514.428,1.938,1.938,0,0,0-.316.6,2.221,2.221,0,0,0-.132.659Z",
    transform: "translate(-162.691 -158.125)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95715",
    "data-name": "Path 95715",
    d: "M246.607,362.3v3.6H245.52V360.28h.843l2.926,3.684v-3.677h1.094v5.608h-.89Z",
    transform: "translate(-165.962 -158.159)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95716",
    "data-name": "Path 95716",
    d: "M254.67,365.894V360.28h3.776v.956h-2.682v1.45h2.227v.883h-2.227v2.326Z",
    transform: "translate(-169.082 -158.159)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95717",
    "data-name": "Path 95717",
    d: "M261.56,365.894V360.28h1.094v5.614Z",
    transform: "translate(-171.432 -158.159)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95718",
    "data-name": "Path 95718",
    d: "M265,365.894V360.28h2.484a1.64,1.64,0,0,1,.718.158,2.043,2.043,0,0,1,.567.428,2.168,2.168,0,0,1,.369.6,1.773,1.773,0,0,1,.132.659,1.852,1.852,0,0,1-.27,1,1.575,1.575,0,0,1-.738.659l1.278,2.115h-1.245l-1.147-1.885h-1.074v1.885Zm1.094-2.84h1.371a.514.514,0,0,0,.277-.072.692.692,0,0,0,.224-.191.869.869,0,0,0,.152-.29,1.061,1.061,0,0,0,.059-.356,1.073,1.073,0,0,0-.066-.362.917.917,0,0,0-.171-.29.845.845,0,0,0-.244-.191.619.619,0,0,0-.283-.066h-1.318Z",
    transform: "translate(-172.605 -158.159)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95719",
    "data-name": "Path 95719",
    d: "M277.56,365.894v-3.717l-1.443,2.768h-.593l-1.45-2.768v3.717H273V360.28h1.173l1.661,3.2,1.674-3.2h1.166v5.614Z",
    transform: "translate(-175.333 -158.159)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95720",
    "data-name": "Path 95720",
    d: "M287.251,364.939v.956h-3.9V360.28h3.829v.956h-2.741v1.318H286.8v.89h-2.366v1.463Z",
    transform: "translate(-178.863 -158.159)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95721",
    "data-name": "Path 95721",
    d: "M290.57,365.894V360.28h2.036a2.959,2.959,0,0,1,1.206.224,2.419,2.419,0,0,1,.87.6,2.5,2.5,0,0,1,.521.89,3.578,3.578,0,0,1,0,2.247,2.451,2.451,0,0,1-1.43,1.45,3.038,3.038,0,0,1-1.147.2Zm3.7-2.814a2.234,2.234,0,0,0-.112-.745,1.589,1.589,0,0,0-.323-.587,1.444,1.444,0,0,0-.521-.382,1.877,1.877,0,0,0-.712-.132h-.949v3.7h.949a1.766,1.766,0,0,0,.718-.145,1.463,1.463,0,0,0,.521-.389,1.706,1.706,0,0,0,.316-.593A2.181,2.181,0,0,0,294.273,363.08Z",
    transform: "translate(-181.325 -158.159)",
    fill: "#ffc727"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Envelope--inject-57",
    transform: "translate(125.948 112.792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95722",
    "data-name": "Path 95722",
    d: "M269.916,275.692H187.36V205.854l41.272-26.214,41.285,26.214Z",
    transform: "translate(-175.722 -160.932)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95723",
    "data-name": "Path 95723",
    d: "M269.916,275.692H187.36V205.854l41.272-26.214,41.285,26.214Z",
    transform: "translate(-175.722 -160.932)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6933",
    "data-name": "Rectangle 6933",
    width: 73.245,
    height: 94.029,
    transform: "translate(16.29 15.387)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95724",
    "data-name": "Path 95724",
    d: "M234.551,236.924,217.78,219.948l5.634-5.568,9.8,9.918,20.349-31.908,6.682,4.257Z",
    transform: "translate(-186.096 -165.28)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95725",
    "data-name": "Path 95725",
    d: "M269.916,246v52.323H187.36V246c3.545,1.977,7.031,4.112,10.544,6.168s6.992,4.191,10.465,6.326c3.868,2.353,7.736,4.751,11.591,7.163l.125-.072c-.04,0-.066.066-.1.086q4.323,2.669,8.652,5.371c2.873-1.812,5.766-3.638,8.652-5.423-.033,0-.059-.059-.1-.086a.572.572,0,0,0,.125.066q5.779-3.6,11.591-7.17,5.212-3.183,10.451-6.313C262.9,250.079,266.371,247.977,269.916,246Z",
    transform: "translate(-175.722 -183.562)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_131858",
    "data-name": "Group 131858",
    transform: "translate(11.638 62.438)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95726",
    "data-name": "Path 95726",
    d: "M269.916,246c-3.334,2.339-6.728,4.613-10.089,6.893s-6.781,4.507-10.194,6.741q-5.338,3.5-10.7,6.932l-.323.224-9.509,6.063-.474.283-.461-.283-9.5-6.076-.336-.211q-5.371-3.44-10.708-6.946c-3.4-2.221-6.794-4.474-10.181-6.728s-6.755-4.586-10.089-6.893c3.545,1.977,7.031,4.112,10.544,6.168s6.992,4.191,10.465,6.326c3.868,2.353,7.736,4.751,11.591,7.163h0q4.349,2.682,8.679,5.384c2.873-1.812,5.766-3.638,8.652-5.423h0q5.779-3.6,11.591-7.17,5.213-3.183,10.451-6.313C262.9,250.079,266.371,247.977,269.916,246Z",
    transform: "translate(-187.36 -246)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95727",
    "data-name": "Path 95727",
    d: "M220.164,275.67c-.04,0-.066.066-.1.086l-1.318,1.107c-2.069,1.746-4.191,3.42-6.346,5.048-2.636,1.977-5.318,3.954-8.02,5.839s-5.443,3.73-8.237,5.516-5.6,3.532-8.514,5.133c2.5-2.194,5.107-4.244,7.736-6.234s5.331-3.954,8.02-5.845,5.456-3.743,8.244-5.529c2.221-1.423,4.481-2.827,6.781-4.138.534-.31,1.068-.606,1.614-.909Z",
    transform: "translate(-187.452 -256.118)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95728",
    "data-name": "Path 95728",
    d: "M295.51,298.4c-2.913-1.6-5.74-3.348-8.514-5.133s-5.549-3.644-8.25-5.516-5.39-3.835-8.02-5.839c-2.142-1.628-4.264-3.295-6.32-5.035l-1.318-1.12c-.033,0-.059-.059-.1-.086a.573.573,0,0,0,.125.066c.547.31,1.081.606,1.614.916,2.3,1.318,4.547,2.715,6.781,4.138,2.788,1.786,5.516,3.644,8.231,5.529s5.39,3.835,8.02,5.845S293.006,296.2,295.51,298.4Z",
    transform: "translate(-213.152 -256.118)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_95729",
    "data-name": "Path 95729",
    d: "M196.229,162.156a45.292,45.292,0,0,1,0-10.906A45.284,45.284,0,0,1,196.229,162.156Z",
    transform: "translate(-178.635 -151.25)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95730",
    "data-name": "Path 95730",
    d: "M185.367,166.44a40.411,40.411,0,0,1-4.092-3.624,39.634,39.634,0,0,1-3.624-4.086,45.471,45.471,0,0,1,7.717,7.71Z",
    transform: "translate(-172.411 -153.801)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95731",
    "data-name": "Path 95731",
    d: "M180.606,177.092a39.9,39.9,0,0,1-5.456.329,38.836,38.836,0,0,1-5.45-.323,38.781,38.781,0,0,1,5.45-.329A39.887,39.887,0,0,1,180.606,177.092Z",
    transform: "translate(-169.7 -159.952)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95732",
    "data-name": "Path 95732",
    d: "M184.89,184.287A45.8,45.8,0,0,1,177.18,192a45.16,45.16,0,0,1,7.71-7.723Z",
    transform: "translate(-172.251 -162.514)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95733",
    "data-name": "Path 95733",
    d: "M302.682,162.156a40.964,40.964,0,0,1-.323-5.456,39.746,39.746,0,0,1,.336-5.45,45.29,45.29,0,0,1,0,10.906Z",
    transform: "translate(-214.94 -151.25)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95734",
    "data-name": "Path 95734",
    d: "M309.89,166.44a45.471,45.471,0,0,1,7.717-7.71,39.627,39.627,0,0,1-3.624,4.086,40.4,40.4,0,0,1-4.092,3.624Z",
    transform: "translate(-217.508 -153.801)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95735",
    "data-name": "Path 95735",
    d: "M313,177.092a39.889,39.889,0,0,1,5.456-.323,38.72,38.72,0,0,1,5.45.329,38.774,38.774,0,0,1-5.45.323A39.89,39.89,0,0,1,313,177.092Z",
    transform: "translate(-218.569 -159.952)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95736",
    "data-name": "Path 95736",
    d: "M310.37,184.29a45.16,45.16,0,0,1,7.71,7.717,40.491,40.491,0,0,1-4.086-3.631,39.7,39.7,0,0,1-3.624-4.086Z",
    transform: "translate(-217.672 -162.517)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-57",
    transform: "translate(43.499 93.807)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95737",
    "data-name": "Path 95737",
    d: "M146.25,435.929c-1.423.461-41.97-.066-43.492-1.068-.586-.369-.857-6.28-.975-13.437V421.2c0-1.47-.046-2.992-.053-4.527v-.659l1.977-21.034,27.123.27-2.682,20.837v.824l-.165,4.31v.448s15.433,7.143,17,8.422S147.667,435.481,146.25,435.929Z",
    transform: "translate(-63.794 -215.652)",
    fill: "#f7a9a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95738",
    "data-name": "Path 95738",
    d: "M146.25,446.814c-1.423.461-41.97-.066-43.492-1.068-.586-.369-.857-6.28-.975-13.437v-.224c0-1.47-.046-2.992-.053-4.527V426.9l26.412.072v.824l-.165,4.31v.448s15.433,7.143,17,8.422S147.667,446.366,146.25,446.814Z",
    transform: "translate(-63.794 -226.538)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95739",
    "data-name": "Path 95739",
    d: "M146.219,449.774c-1.437.461-42.352.072-43.9-.929-.593-.376-.883-6.339-1.028-13.555l26.359.178s15.6,7.156,17.186,8.435S147.649,449.306,146.219,449.774Z",
    transform: "translate(-63.644 -229.399)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95740",
    "data-name": "Path 95740",
    d: "M147.191,454.592c-6.853-.237-34.537-.534-41.331-.244-.053,0-.053.04,0,.046,6.794.376,34.471.448,41.331.31C147.335,454.7,147.335,454.592,147.191,454.592Z",
    transform: "translate(-65.188 -235.857)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95741",
    "data-name": "Path 95741",
    d: "M160.477,446.088a5.542,5.542,0,0,0-4.119,1.634,5.371,5.371,0,0,0-1.568,3.651c0,.04.079.04.086,0a6.366,6.366,0,0,1,5.6-5.2.046.046,0,1,0,0-.086Z",
    transform: "translate(-81.888 -233.08)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95742",
    "data-name": "Path 95742",
    d: "M141.374,436.638c-2.748-.066-5.931.87-7.664,3.1-.066.092.059.185.138.138a38.134,38.134,0,0,1,7.572-2.9.171.171,0,0,0-.046-.336Z",
    transform: "translate(-74.693 -229.858)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95743",
    "data-name": "Path 95743",
    d: "M144.574,437.918c-2.741-.066-5.931.876-7.664,3.1-.066.086.059.178.138.138a37.91,37.91,0,0,1,7.572-2.906.171.171,0,0,0-.046-.336Z",
    transform: "translate(-75.785 -230.294)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95744",
    "data-name": "Path 95744",
    d: "M147.784,439.2c-2.748-.059-5.931.876-7.664,3.1-.066.086.053.185.138.138a38.223,38.223,0,0,1,7.565-2.9.178.178,0,0,0-.04-.343Z",
    transform: "translate(-76.879 -230.731)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95745",
    "data-name": "Path 95745",
    d: "M151.024,440.488c-2.741-.066-5.931.876-7.664,3.1-.066.086.059.178.138.138a37.912,37.912,0,0,1,7.525-2.906.171.171,0,0,0,0-.336Z",
    transform: "translate(-77.984 -231.171)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95746",
    "data-name": "Path 95746",
    d: "M107.427,444.55c-3.084,0-3.117,4.764,0,4.784S110.511,444.57,107.427,444.55Z",
    transform: "translate(-64.943 -232.557)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95747",
    "data-name": "Path 95747",
    d: "M146.59,425.3c-1.377-1.166-3.143-.053-4.007,1.133a14.392,14.392,0,0,0-2.583,7,.078.078,0,0,0,.086.079.329.329,0,0,0,.488.224c1.977-1.318,4.237-2.517,5.74-4.409C147.183,428.23,147.868,426.412,146.59,425.3Zm-3.427,5.806c-.949.659-1.931,1.318-2.853,2.023a42.628,42.628,0,0,1,1.582-4.053,16.214,16.214,0,0,1,1.021-1.845c.606-.9,3.295-3.17,3.565-.178.112,1.647-2.208,3.242-3.341,4.053Z",
    transform: "translate(-76.845 -225.825)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95748",
    "data-name": "Path 95748",
    d: "M128.116,436.881c2.392.389,4.863-.264,7.216-.606a.343.343,0,0,0,.211-.5.073.073,0,0,0,0-.112,14.353,14.353,0,0,0-6.59-3.44c-1.443-.3-3.493.073-3.723,1.865C125,435.781,126.725,436.657,128.116,436.881Zm-1.641-1.542c-1.832-2.372,1.7-2.53,2.755-2.273a15.158,15.158,0,0,1,1.977.659,42.148,42.148,0,0,1,3.908,1.924c-1.166.1-2.313.3-3.479.435C130.27,436.229,127.489,436.611,126.475,435.339Z",
    transform: "translate(-71.8 -228.322)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95749",
    "data-name": "Path 95749",
    d: "M123.043,449.84c-10.168-.178-19.98-.514-20.725-1-.593-.376-.883-6.339-1.028-13.555h3.756C109.2,438.69,117.982,445.761,123.043,449.84Z",
    transform: "translate(-63.644 -229.399)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95750",
    "data-name": "Path 95750",
    d: "M122.248,360.93h-29.2s5.878-68.2,5.647-69.39c-.29-1.529-2.016-8.428-4.31-17.45-.718-2.82-1.5-5.845-2.3-8.982-2.181-8.488-4.613-17.759-6.669-25.832C82.281,227.19,79.83,217.8,79.83,217.8h24.745s2.886,9.14,6.524,21.041c5.931,19.328,13.838,45.937,14.616,52.408C126.98,301.681,122.248,360.93,122.248,360.93Z",
    transform: "translate(-56.325 -155.23)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95751",
    "data-name": "Path 95751",
    d: "M128.654,427.315c-4.461-.092-3.183-.125-7.644-.171-2.181,0-16.521-.145-18.563.191a.046.046,0,0,0,0,.092c2.043.336,16.382.211,18.563.191,4.461-.04,3.183-.079,7.644-.171a.066.066,0,1,0,0-.132Z",
    transform: "translate(-64.022 -226.61)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95752",
    "data-name": "Path 95752",
    d: "M106.8,290.545c-.956-4.217-2.392-8.356-3.638-12.521q-3.8-12.619-7.638-25.239-1.918-6.306-3.848-12.613-.975-3.183-1.977-6.359c-.659-2.076-1.39-4.125-1.977-6.221-.237-.85-.369-.382-.059.7.613,2.175,1.219,4.356,1.858,6.53q1.878,6.458,3.8,12.9,3.8,12.83,7.657,25.641,1.931,6.432,3.868,12.85a51.781,51.781,0,0,1,1.575,6.221,28.415,28.415,0,0,1,.264,6.649c-.283,4.468-.8,8.929-1.213,13.384s-.83,8.936-1.239,13.4Q103,339.2,101.781,352.535c-.1,1.127-.2,2.254-.283,3.387,0,.376.54.343.58,0,.962-8.784,1.7-17.608,2.524-26.405s1.647-17.522,2.465-26.28c.2-2.2.442-4.4.442-6.59A27.38,27.38,0,0,0,106.8,290.545Z",
    transform: "translate(-58.936 -158.42)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95753",
    "data-name": "Path 95753",
    d: "M101.767,217.78c-1.72,13.292-5,38.221-7.381,56.29-5.582-21.878-14.557-56.29-14.557-56.29Z",
    transform: "translate(-56.325 -155.223)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95754",
    "data-name": "Path 95754",
    d: "M99.266,436.614c-1.417.461-41.964.086-43.492-.909-.586-.369-.876-6.28-1.021-13.437v-.224c-.033-1.469-.059-2.992-.066-4.527v-.659c-.092-10.32.659-21.028.659-21.028l26.5.171L81.1,416.838v.824l-.145,4.316v.441s15.387,7.13,16.955,8.382S100.689,436.14,99.266,436.614Z",
    transform: "translate(-47.748 -215.942)",
    fill: "#f7a9a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95755",
    "data-name": "Path 95755",
    d: "M99.27,447.5c-1.417.461-41.964.086-43.492-.909-.586-.369-.876-6.28-1.021-13.437v-.224c-.033-1.469-.059-2.992-.066-4.527v-.659H81.1v.824l-.145,4.316v.442s15.394,7.11,16.962,8.362S100.693,447.022,99.27,447.5Z",
    transform: "translate(-47.752 -226.824)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95756",
    "data-name": "Path 95756",
    d: "M99.339,450.094c-1.437.461-42.352.072-43.9-.929-.593-.376-.883-6.339-1.028-13.555l26.359.178s15.6,7.156,17.179,8.435S100.769,449.626,99.339,450.094Z",
    transform: "translate(-47.656 -229.508)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95757",
    "data-name": "Path 95757",
    d: "M100.31,454.912c-6.86-.237-34.537-.534-41.331-.244-.053,0-.053.04,0,.04,6.787.382,34.471.455,41.331.316C100.455,455.017,100.455,454.912,100.31,454.912Z",
    transform: "translate(-49.201 -235.966)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95758",
    "data-name": "Path 95758",
    d: "M113.6,446.408a5.535,5.535,0,0,0-4.119,1.634,5.344,5.344,0,0,0-1.568,3.651c0,.04.079.04.086,0a6.366,6.366,0,0,1,5.6-5.2.046.046,0,0,0,0-.086Z",
    transform: "translate(-65.901 -233.19)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95759",
    "data-name": "Path 95759",
    d: "M94.494,437c-2.748-.059-5.931.876-7.664,3.1-.066.086.053.185.138.138a38.135,38.135,0,0,1,7.572-2.9.178.178,0,0,0-.046-.343Z",
    transform: "translate(-58.706 -229.981)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95760",
    "data-name": "Path 95760",
    d: "M97.694,438.238c-2.741-.066-5.931.87-7.664,3.1-.066.086.059.178.138.138a37.91,37.91,0,0,1,7.572-2.906.171.171,0,0,0-.046-.336Z",
    transform: "translate(-59.797 -230.403)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95761",
    "data-name": "Path 95761",
    d: "M100.9,439.518c-2.748-.066-5.931.876-7.664,3.1-.072.086.053.178.138.138a37.673,37.673,0,0,1,7.565-2.9.178.178,0,0,0-.04-.343Z",
    transform: "translate(-60.89 -230.84)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95762",
    "data-name": "Path 95762",
    d: "M104.1,440.808c-2.748-.066-5.931.87-7.664,3.1-.066.086.059.178.138.138a37.753,37.753,0,0,1,7.572-2.906.171.171,0,0,0-.046-.336Z",
    transform: "translate(-61.983 -231.28)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95763",
    "data-name": "Path 95763",
    d: "M60.547,444.87c-3.084,0-3.117,4.764,0,4.784S63.631,444.89,60.547,444.87Z",
    transform: "translate(-48.956 -232.666)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95764",
    "data-name": "Path 95764",
    d: "M99.68,425.624c-1.384-1.166-3.143-.053-4.013,1.133a14.385,14.385,0,0,0-2.557,6.992.072.072,0,0,0,.086.079.329.329,0,0,0,.488.231c1.977-1.318,4.237-2.517,5.74-4.415C100.286,428.537,100.985,426.725,99.68,425.624Zm-3.427,5.806c-.949.659-1.931,1.318-2.853,2.016a42.631,42.631,0,0,1,1.614-4.053,16.125,16.125,0,0,1,1.021-1.839c.606-.9,3.295-3.17,3.565-.185.105,1.628-2.214,3.249-3.348,4.059Z",
    transform: "translate(-60.854 -225.934)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95765",
    "data-name": "Path 95765",
    d: "M81.232,437.206c2.385.389,4.863-.27,7.209-.606a.336.336,0,0,0,.211-.488.072.072,0,0,0,0-.119,14.451,14.451,0,0,0-6.59-3.44c-1.443-.29-3.493.079-3.723,1.872C78.109,436.112,79.842,436.976,81.232,437.206Zm-1.641-1.582c-1.832-2.372,1.7-2.524,2.755-2.267a15.159,15.159,0,0,1,1.977.659,42.867,42.867,0,0,1,3.9,1.924c-1.166.1-2.313.29-3.473.435C83.38,436.554,80.606,436.936,79.591,435.625Z",
    transform: "translate(-55.81 -228.436)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95766",
    "data-name": "Path 95766",
    d: "M94.027,217.78S93.454,229.642,90.732,239c-.217.778-.455,1.535-.705,2.267a44.214,44.214,0,0,0-7.124,3.677s-.283,9.522-.567,20.151c-.316,11.862-.659,25.12-.58,27.934.25,10.544-1.318,68.316-1.318,68.316l-29.2.119s5.272-64.58,5.272-68.408c-.059-6.188,1.41-33.548,2.55-53.5.659-12.3,1.265-21.746,1.265-21.746Z",
    transform: "translate(-46.575 -155.223)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95767",
    "data-name": "Path 95767",
    d: "M80.417,427.674c-4.461-.072-3.183-.112-7.638-.138-2.188,0-16.527-.079-18.563.27a.046.046,0,1,0,0,.092c2.036.329,16.382.138,18.563.112,4.461-.066,3.176-.092,7.638-.2a.066.066,0,0,0,0-.132Z",
    transform: "translate(-47.574 -226.752)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95768",
    "data-name": "Path 95768",
    d: "M64.9,224.144c-.54,16.29-1.107,32.58-1.839,48.856s-1.713,32.672-3.077,48.962c-.764,9.107-1.489,21.918-2.471,30.972,0,.059.086.086.1,0,2.122-16.158,3.295-36.132,4.356-52.4s1.753-32.54,2.306-48.817c.316-9.226.554-18.451.83-27.637C65.082,224.012,64.9,224.012,64.9,224.144Z",
    transform: "translate(-48.713 -157.356)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95769",
    "data-name": "Path 95769",
    d: "M107.646,252.349a54.693,54.693,0,0,0-8.376,4.382.1.1,0,0,0,.092.171c2.814-1.371,5.687-2.689,8.428-4.211a.191.191,0,0,0-.145-.343Z",
    transform: "translate(-62.942 -167.011)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95770",
    "data-name": "Path 95770",
    d: "M109.482,237.084c-.2,1.035-.448,2.063-.659,3.1s-.362,1.977-.619,2.913a5.015,5.015,0,0,1-1.357,2.438c-.376.349-.8.659-1.2.988l-.659.521a3.37,3.37,0,0,1,.079-.422c.072-.4.138-.784.2-1.18.145-.876.283-1.753.422-2.636.264-1.727.5-3.466.863-5.166,0-.072-.092-.1-.105,0-.428,1.687-.9,3.354-1.278,5.061-.185.837-.837,4.962-.863,5.272s-.059.606-.066.909a3.294,3.294,0,0,0,0,.923c0,.079.105.066.138,0h0a3.433,3.433,0,0,0,.264-.9c.079-.29.145-.593.2-.89a.832.832,0,0,1,.046-.329c.409-.244.784-.573,1.166-.85s.83-.586,1.213-.909a4.646,4.646,0,0,0,1.417-2.326,16.77,16.77,0,0,0,.488-2.965c.132-1.173.224-2.353.389-3.519C109.6,237.011,109.5,237.011,109.482,237.084Z",
    transform: "translate(-64.64 -161.789)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95771",
    "data-name": "Path 95771",
    d: "M95.158,171.6c2.26,6.807,12.382,28.448,16.633,29.964,4.428,1.568,21.529,3.526,25.324.54,1.858-1.469,2.5-17.133,0-16.738s-17.581.942-19.374.3S103.975,167.6,99.112,163.359C90.723,156.078,93.952,167.933,95.158,171.6Z",
    transform: "translate(-60.998 -135.873)",
    fill: "#f7a9a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95772",
    "data-name": "Path 95772",
    d: "M133.114,185.093l-.244,19.5s-17.535.046-22.207-2.412-14.557-24.988-17.028-33.608,1.483-9.951,7.763-3.624,15.723,19.585,16.843,19.855S133.114,185.093,133.114,185.093Z",
    transform: "translate(-60.779 -135.86)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95773",
    "data-name": "Path 95773",
    d: "M111.763,179.813a35.737,35.737,0,0,0-10.359,3.427l-.593.31c-.152.072-.3.152-.442.237-.29.152-.573.31-.857.481l-.125-.316.6-.349.435-.231c.27-.152.547-.3.824-.442a33.033,33.033,0,0,1,5.212-2.161,34.675,34.675,0,0,1,5.087-1.232Zm3.914,4.923a10.423,10.423,0,0,1-.955.442,9.786,9.786,0,0,1-2.636.7c-.461.053-.923.132-1.384.158l-1.39.04a15.334,15.334,0,0,1-5.417-1.147c-1.035-.4-2.043-.89-3.051-1.377-.132-.053-.257-.119-.389-.178-.316-.145-.659-.3-.956-.435l-.31-.132-.29-.125.112.277c0,.079.066.158.092.237h.059l.85.382.382.185c1.094.521,2.194,1.074,3.341,1.522a15.769,15.769,0,0,0,5.562,1.18l1.423-.033a12.774,12.774,0,0,0,1.417-.165,10.321,10.321,0,0,0,2.768-.718,10.544,10.544,0,0,0,1.074-.494Zm-6.748-8.4a35.449,35.449,0,0,0-3.591,1.924,46.859,46.859,0,0,0-6.181,4.54l-.178.152c0,.079.066.158.092.237h0v.053h.04c.112-.1.217-.2.329-.283a46.786,46.786,0,0,1,6.056-4.376,40.95,40.95,0,0,1,3.644-1.937Z",
    transform: "translate(-62.828 -141.091)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95774",
    "data-name": "Path 95774",
    d: "M146.147,207.4c0-1.549.112-7.723.25-9.226h.046c.152,1.489.231,7.585.224,9.133a84.954,84.954,0,0,1-.349,9.226.053.053,0,0,1-.1,0C145.989,213.491,146.114,210.44,146.147,207.4Z",
    transform: "translate(-78.919 -148.535)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95775",
    "data-name": "Path 95775",
    d: "M93.62,168.556c2.471,8.626,12.356,31.15,17.028,33.608,2.241,1.18,7.433,1.786,12.237,2.089L95.366,160.991C93.013,160.741,92.124,163.291,93.62,168.556Z",
    transform: "translate(-60.777 -135.851)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95776",
    "data-name": "Path 95776",
    d: "M60.353,215.449c.105.105,42.886-2.82,43.242-3.295.5-.659-13.041-44.151-16.435-50.511-1.443-2.722-8.362-3.117-11.1-.54-6.847,6.438-11.611,27.255-12.613,33.5C61.79,204.893,59.971,215.074,60.353,215.449Z",
    transform: "translate(-49.666 -135.304)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95777",
    "data-name": "Path 95777",
    d: "M102.164,220.636l-1.2-.705a53.154,53.154,0,0,0-4.988-2.563l-.936-.409-.455-.185a32.3,32.3,0,0,0-3.868-1.318,28.955,28.955,0,0,0-5.5-.975,35.908,35.908,0,0,0-11.077,1.252l-.659.185c-.165.04-.323.086-.481.138A45.622,45.622,0,0,0,65.7,219c-.659.31-1.318.659-1.924.982l-.2.105-.725.389.059-.336.745-.382c.738-.4,1.483-.791,2.234-1.153.619-.316,1.252-.613,1.885-.9a44.816,44.816,0,0,1,4.89-1.9l.481-.138c.3-.1.593-.185.9-.264a32.289,32.289,0,0,1,5.549-1.048,34.267,34.267,0,0,1,5.641-.145,31.019,31.019,0,0,1,9.6,2.405l.448.2.784.349a51.956,51.956,0,0,1,4.988,2.636l1.028.606Zm-2.214-7.249c-1.094.659-2.161,1.318-3.222,2.016-.659.409-1.259.824-1.891,1.226l-.25.165c-.863.554-1.74,1.087-2.636,1.588a16.97,16.97,0,0,1-5.173,1.977,9.951,9.951,0,0,1-2.761.138c-.461-.046-.929-.059-1.384-.125l-1.371-.244a15.452,15.452,0,0,1-5.068-2.234c-.929-.606-1.812-1.318-2.708-1.977l-.343-.257c-.277-.211-.56-.422-.843-.619l-.27-.2-.4-.27a9.885,9.885,0,0,0-5.357-1.825,6.181,6.181,0,0,0-2.214.455l-.059.356a6.181,6.181,0,0,1,2.267-.474,9.522,9.522,0,0,1,5.147,1.812l.231.158.27.191c.25.178.5.362.745.554l.343.257c.969.738,1.931,1.5,2.965,2.175a15.763,15.763,0,0,0,5.193,2.293l1.41.257c.468.066.942.086,1.417.132a10.682,10.682,0,0,0,2.86-.138,17.133,17.133,0,0,0,5.272-2.043c.982-.554,1.937-1.153,2.88-1.773l.244-.152,1.661-1.087q1.542-.988,3.124-1.977Zm-.725-2.333a33.512,33.512,0,0,0-3.486-.923,26.109,26.109,0,0,0-5.634-.514,32.947,32.947,0,0,0-5.634.593,36.551,36.551,0,0,0-5.463,1.476,46.489,46.489,0,0,0-6.972,3.176c-.132.066-.257.138-.382.211-.936.521-1.852,1.061-2.761,1.621-1.008.619-2.01,1.259-3,1.9-.771.494-1.535,1-2.3,1.5l-.738.481a2.237,2.237,0,0,1-.046.3c.975-.619,1.937-1.252,2.906-1.871.659-.442,1.371-.883,2.063-1.318.415-.264.83-.521,1.252-.771.949-.573,1.918-1.133,2.893-1.667l.382-.2a46.088,46.088,0,0,1,6.82-3.044,36.54,36.54,0,0,1,10.979-2.1,26.01,26.01,0,0,1,5.582.474,33.033,33.033,0,0,1,3.631.949c-.033-.112-.066-.211-.092-.3Z",
    transform: "translate(-50.521 -152.438)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95778",
    "data-name": "Path 95778",
    d: "M65.156,167.071C53.8,179.592,41,200.752,46.474,205.292c5.008,4.125,23.275.2,34.761-4.29,2.188-.857-6.682-20.191-8.909-19.044a63.682,63.682,0,0,1-7.249,3.295c-.659.171,2.82-4.046,6.669-14.181C75.634,160.719,71.647,159.908,65.156,167.071Z",
    transform: "translate(-44.504 -136.33)",
    fill: "#f7a9a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95779",
    "data-name": "Path 95779",
    d: "M113.626,187.366c0,2.247-5.529,1.806-5.529,1.806a4.119,4.119,0,0,1,1.687,2.234c.415,1.654-1.977,3.038-1.977,3.038a5.147,5.147,0,0,1,1.4,2.636c.237,1.621-1.977,3.367-1.977,3.367a4.488,4.488,0,0,1-.25,3.117c-1.318,2.563-5.746,2.636-8.481,3.189a58.035,58.035,0,0,0-8.975,2.86l-5.087-20.2S96.3,182.37,99.6,182.529C102.377,182.72,113.613,183.926,113.626,187.366Z",
    transform: "translate(-57.897 -143.2)",
    fill: "#f7a9a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95780",
    "data-name": "Path 95780",
    d: "M115.534,191.934a37.522,37.522,0,0,0-9.1-1.114.053.053,0,0,0,0,.105c3.018.072,6.082.956,9.081,1.153a.073.073,0,1,0,.02-.145Z",
    transform: "translate(-65.38 -146.029)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95781",
    "data-name": "Path 95781",
    d: "M115.208,200.229a7.908,7.908,0,0,0-2.082-.112c-.738,0-1.476.033-2.214.066q-2.221.1-4.428.316a.053.053,0,0,0,0,.105c1.476-.066,2.952-.112,4.422-.119h2.214a9.225,9.225,0,0,0,2.089-.066.105.105,0,0,0,0-.191Z",
    transform: "translate(-65.397 -149.191)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95782",
    "data-name": "Path 95782",
    d: "M114.747,209.768a5.443,5.443,0,0,0-1.878,0l-1.99.125c-1.318.072-2.7.152-4.046.178a.053.053,0,0,0,0,.105c1.371,0,2.741,0,4.112-.059l2.016-.059a5.126,5.126,0,0,0,1.819-.217.04.04,0,1,0-.033-.072Z",
    transform: "translate(-65.516 -152.463)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95783",
    "data-name": "Path 95783",
    d: "M70.131,182.3l4.376,21.746s-27.2,7.1-30.016.217,13.18-32.428,22.405-39.716,5.759,4.191,5.476,5.114c-1.245,4.079-7.044,14.715-7.044,14.715Z",
    transform: "translate(-44.161 -136.246)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95784",
    "data-name": "Path 95784",
    d: "M74.507,204s-27.2,7.1-30.016.217c-1.516-3.7,2.412-12.8,7.8-21.562l.086-.138.112-.178c.033-.059.072-.119.112-.178a108.646,108.646,0,0,1,6.3-9.087l.231-.3a50.939,50.939,0,0,1,7.756-8.277c9.226-7.288,5.759,4.191,5.476,5.114-.086.29-.2.613-.329.962-.053.132-.105.277-.165.422-.758,1.937-1.977,4.547-3.209,6.946l-.145.29a.115.115,0,0,1-.046.092l-.079.152c-1.562,3.077-2.979,5.687-3.064,5.845l4.811-2.043Z",
    transform: "translate(-44.161 -136.232)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95785",
    "data-name": "Path 95785",
    d: "M72.869,182.337l-.145.29a.115.115,0,0,1-.046.092l-.329.211-2.682,1.746a40.283,40.283,0,0,1-4.923,2.768,12.817,12.817,0,0,1-2.7.9,5.562,5.562,0,0,1-2.847-.086c-.231-.066-.468-.119-.659-.191l-.659-.283a9.3,9.3,0,0,1-1.265-.659l-.1-.059.086-.138.112-.178a.475.475,0,0,0,.1.072l.092.053a7.361,7.361,0,0,0,1.12.606l.659.277.659.191a5.272,5.272,0,0,0,2.7.1,12.7,12.7,0,0,0,2.636-.857,40.759,40.759,0,0,0,4.9-2.7l2.142-1.371.56-.362Zm-.659.4c-3.381.824-6.7,1.871-10.069,2.7-1.766.442-3.558.83-5.357,1.12-.04.059-.079.119-.112.178l-.112.178.3-.053c1.8-.3,3.585-.705,5.351-1.153,3.17-.8,6.28-1.786,9.437-2.6l.659-.171a1.954,1.954,0,0,0,.25-.059l.079-.152a.122.122,0,0,1,.046-.092Zm.217-5.476a15.731,15.731,0,0,1-2.563,1.1,6.775,6.775,0,0,1-2.7.343,8.718,8.718,0,0,1-3.848-1.535l-.231.3a9.1,9.1,0,0,0,4.04,1.575,7.005,7.005,0,0,0,2.84-.382,15.276,15.276,0,0,0,2.636-1.14,40.021,40.021,0,0,0,3.486-2.128c.059-.145.112-.29.165-.422a42.572,42.572,0,0,1-3.8,2.293Z",
    transform: "translate(-48.376 -140.624)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95786",
    "data-name": "Path 95786",
    d: "M76.071,192.668c-3.124,1.094-11.308,5.18-13.107,6.853a.059.059,0,0,0,.066.092c1.766-1.245,11.862-6.194,13.463-6.8,0,0,.079.191.112.244s.092.033.092-.04a4.125,4.125,0,0,0-.119-.527Z",
    transform: "translate(-50.569 -146.598)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95787",
    "data-name": "Path 95787",
    d: "M78.5,206.473c-.3-1.516-1.43-7.591-1.595-9.12,0,0,0-.033.04,0,.448,1.423,1.74,7.387,2.043,8.9a84.041,84.041,0,0,1,1.509,9.133c0,.053-.079.086-.1,0C79.605,212.476,79.085,209.458,78.5,206.473Z",
    transform: "translate(-55.329 -148.252)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95788",
    "data-name": "Path 95788",
    d: "M75.939,190.39c.85-1.852,1.891-3.611,2.827-5.417s1.9-3.6,2.774-5.423h.04c-.527,1.245-1.054,2.491-1.621,3.717.171-.191.329-.4.488-.6.29-.369.554-.758.817-1.147h.04a6.333,6.333,0,0,1-.758,1.226,6.939,6.939,0,0,1-.725.8c-.231.5-.474,1-.725,1.5a39.849,39.849,0,0,1-2.84,5.311C76.215,190.476,75.906,190.476,75.939,190.39Z",
    transform: "translate(-54.997 -142.185)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95789",
    "data-name": "Path 95789",
    d: "M62.2,228.286c3.209-.04,15.328-2.418,18.326-3.038-.04-.316,0-.428-.079-.876,0-.059.086-.086.1,0,.079.428.369,1.278.25,1.318-1.443.567-15.446,3.012-18.6,2.748a.076.076,0,0,1,0-.152Z",
    transform: "translate(-50.287 -157.452)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95790",
    "data-name": "Path 95790",
    d: "M111.76,210.784l22.563,3.038,8.56-31.361L120.32,179.43Z",
    transform: "translate(-67.214 -142.145)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95791",
    "data-name": "Path 95791",
    d: "M113.45,211l22.557,3.038,8.56-31.354L122.01,179.65Z",
    transform: "translate(-67.79 -142.22)",
    fill: "#37474f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95792",
    "data-name": "Path 95792",
    d: "M139.537,202.946a2.465,2.465,0,0,1-2.682,1.871,1.977,1.977,0,0,1-1.707-2.458,2.471,2.471,0,0,1,2.682-1.878,1.977,1.977,0,0,1,1.707,2.465Z",
    transform: "translate(-75.169 -149.318)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95793",
    "data-name": "Path 95793",
    d: "M152.817,194.07c.942,2.636,3.631,6.069,3.67,8.152a2.4,2.4,0,0,1-1.575,2.379s1.977,1.232,1.667,3.124c-.138.975-1.825,1.608-1.825,1.608a2.834,2.834,0,0,1,1.166,2.722c-.277,1.318-1.924,1.759-1.924,1.759s.988,1.694.27,2.959c-1.463,2.563-13.067,1.384-14.425-3.077-.659-2.076,2.181-1.634,2.181-1.634s-3.9-1.615-3.717-4.013,3.809-1.608,3.809-1.608-3.763-1.595-3.295-4.066,3.954-1.153,3.954-1.153-2.405-1.977-1.634-3.822c1.272-3,5.766,1.39,8.376,1.041l1.839-4.066Z",
    transform: "translate(-76.265 -147.137)",
    fill: "#f7a9a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95794",
    "data-name": "Path 95794",
    d: "M161.312,195.127c-.659-2.577,2.715-5.331,2.425-7.908-.389-3.46-4.534-.527-5.878,4.3l-.389,3.954Z",
    transform: "translate(-82.802 -144.286)",
    fill: "#f7a9a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95795",
    "data-name": "Path 95795",
    d: "M155.578,223.1a.033.033,0,1,1,0,.066,20.263,20.263,0,0,1-11.862-1.931c-.119-.059-.066-.277.072-.231A41.345,41.345,0,0,0,155.578,223.1Z",
    transform: "translate(-78.089 -156.321)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95796",
    "data-name": "Path 95796",
    d: "M156.65,215.693c.046,0,.046.079,0,.086a18.978,18.978,0,0,1-12.837-2.9c-.132-.092-.158-.3,0-.211C146.469,214.2,152.881,215.634,156.65,215.693Z",
    transform: "translate(-78.108 -153.472)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95797",
    "data-name": "Path 95797",
    d: "M144.658,204.493a26.413,26.413,0,0,0,12.224,3.684c.053,0,.046.086,0,.092a16.987,16.987,0,0,1-7.058-.7,11.617,11.617,0,0,1-5.239-2.946C144.519,204.566,144.579,204.441,144.658,204.493Z",
    transform: "translate(-78.399 -150.687)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95798",
    "data-name": "Path 95798",
    d: "M96.49,164.481h0c.079,1.977.138,6.465-2.906,6.128a6.5,6.5,0,0,1-3.249-1.7,16.811,16.811,0,0,1-2.59-2.689A25.755,25.755,0,0,1,85.4,162.8c0-.046-.105,0-.072.053.7,1.206,1.278,2.451,2.1,3.591A14.919,14.919,0,0,0,90.15,169.4a6.491,6.491,0,0,0,3.526,1.674,2.451,2.451,0,0,0,2.537-1.8,10.84,10.84,0,0,0,.277-4.8Z",
    transform: "translate(-58.197 -136.467)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95799",
    "data-name": "Path 95799",
    d: "M94.173,163.622c-2.2.191-5.8-3.954-6.853-6.768a44.72,44.72,0,0,1,1.048-4.349c.336-1.39.659-2.952.9-4.4L98,151.636a23.44,23.44,0,0,0-1.687,5.423,3.09,3.09,0,0,0,0,.6s0,.066,0,.1C96.335,158.911,96.3,163.438,94.173,163.622Z",
    transform: "translate(-58.879 -131.464)",
    fill: "#f7a9a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95800",
    "data-name": "Path 95800",
    d: "M97.6,157.785a.486.486,0,0,1,0,.1,6.042,6.042,0,0,1-.936-.079c-5.232-.89-5.529-7.486-5.5-9.324l2.188.876,5.931,2.405a23.223,23.223,0,0,0-1.68,5.423A3.138,3.138,0,0,0,97.6,157.785Z",
    transform: "translate(-60.188 -131.59)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95801",
    "data-name": "Path 95801",
    d: "M88.632,130.286c-.909,3.295,1.041,12.606,3.4,14.636,3.427,2.952,8.909,3.1,11.387-.988,2.4-3.954-.356-16.086-2.985-17.918C96.566,123.308,89.97,125.449,88.632,130.286Z",
    transform: "translate(-59.249 -123.525)",
    fill: "#f7a9a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95802",
    "data-name": "Path 95802",
    d: "M102.556,142.05s-.04.04,0,.066c.145.626.211,1.371-.316,1.694v.033C102.892,143.605,102.8,142.623,102.556,142.05Z",
    transform: "translate(-63.967 -129.397)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95803",
    "data-name": "Path 95803",
    d: "M101.35,141.228c-1.028.132-.659,2.175.257,2.056S102.226,141.123,101.35,141.228Z",
    transform: "translate(-63.453 -129.115)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95804",
    "data-name": "Path 95804",
    d: "M108.149,141s.059,0,.059.053c.086.659.29,1.351.9,1.47v.033C108.387,142.555,108.13,141.606,108.149,141Z",
    transform: "translate(-65.982 -129.039)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95805",
    "data-name": "Path 95805",
    d: "M108.61,139.829c1.008-.244,1.423,1.786.488,1.977S107.767,140.034,108.61,139.829Z",
    transform: "translate(-65.982 -128.633)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95806",
    "data-name": "Path 95806",
    d: "M99.86,139.171a6.277,6.277,0,0,0,.745-.409,1.318,1.318,0,0,0,.659-.56.441.441,0,0,0-.158-.514,1.087,1.087,0,0,0-1.1.066,1.6,1.6,0,0,0-.791.83.468.468,0,0,0,.646.587Z",
    transform: "translate(-62.925 -127.869)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95807",
    "data-name": "Path 95807",
    d: "M108.907,138.243c-.29,0-.56-.053-.85-.079a1.384,1.384,0,0,1-.85-.244.448.448,0,0,1-.059-.534,1.087,1.087,0,0,1,1.035-.376,1.581,1.581,0,0,1,1.061.448.468.468,0,0,1-.336.784Z",
    transform: "translate(-65.62 -127.672)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95808",
    "data-name": "Path 95808",
    d: "M102.819,151.044a1.008,1.008,0,0,0,.6.29,1.733,1.733,0,0,0,.659-.277s.046,0,0,.033a.876.876,0,0,1-.751.474.692.692,0,0,1-.586-.481C102.753,151.05,102.8,151.011,102.819,151.044Z",
    transform: "translate(-64.138 -132.46)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95809",
    "data-name": "Path 95809",
    d: "M103.391,143.988a2.208,2.208,0,0,0,1.6.725,2.9,2.9,0,0,0,.784-.092l.145-.04.132-.046a.158.158,0,0,0,.105-.165h0a.191.191,0,0,0,0-.066h0v-.053c-.066-.494-.237-1.226-.237-1.226.191.059,1.173.323,1.114.066a32.667,32.667,0,0,0-1.9-6.392.059.059,0,0,0-.112,0c.369,2.03,1.1,3.954,1.509,6a3.756,3.756,0,0,0-1.074-.138c-.066,0,.356,1.41.362,1.634h0a3.038,3.038,0,0,1-2.346-.329C103.391,143.889,103.344,143.942,103.391,143.988Z",
    transform: "translate(-64.354 -127.559)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95810",
    "data-name": "Path 95810",
    d: "M105.48,148.314a2.6,2.6,0,0,1-.883.942,1.14,1.14,0,0,1-.659.152c-.521-.046-.606-.5-.58-.909a2.669,2.669,0,0,1,.125-.659A3.334,3.334,0,0,0,105.48,148.314Z",
    transform: "translate(-64.347 -131.372)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95811",
    "data-name": "Path 95811",
    d: "M104.6,149.6a1.14,1.14,0,0,1-.659.152c-.521-.046-.606-.5-.58-.909A1.186,1.186,0,0,1,104.6,149.6Z",
    transform: "translate(-64.347 -131.712)",
    fill: "#ff9abb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95812",
    "data-name": "Path 95812",
    d: "M101.943,128.6c-.527-.731-1.107-1.463-1.634-1.522s-.586,1.206-1.68,1.522c-1.483.422-2.5-.8-4.613-.494-3.064.442-3.848,3.249-3,7.539.758,3.835-1.47,4.692-1.47,4.692s-3.216-8.125-1.443-11.427,6.959-5.707,11.2-3.829C100.816,125.758,101.943,128.6,101.943,128.6Z",
    transform: "translate(-58.965 -123.385)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95813",
    "data-name": "Path 95813",
    d: "M90.815,144.171s-2.26-2.932-3.6-2.115.448,5.14,2.1,5.667a1.634,1.634,0,0,0,2.155-.982Z",
    transform: "translate(-58.685 -129.35)",
    fill: "#f7a9a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95814",
    "data-name": "Path 95814",
    d: "M88.28,144v.046a4.158,4.158,0,0,1,2.26,2.5.909.909,0,0,0-1.371-.185s0,.066.033.059a1.015,1.015,0,0,1,1.133.3,5.573,5.573,0,0,1,.573.876c.053.1.237.04.191-.079h0C91.054,146.036,89.842,144.066,88.28,144Z",
    transform: "translate(-59.207 -130.062)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95815",
    "data-name": "Path 95815",
    d: "M94.672,123.383a13.938,13.938,0,0,0-3.954-.534c-1.509.046-6.1,1.133-7.071,2.241s-.573,5.535-.5,6.181.962,4.474,2.517,5.193.659-5.891,2.524-8.422S94.672,123.383,94.672,123.383Z",
    transform: "translate(-57.408 -122.849)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95816",
    "data-name": "Path 95816",
    d: "M95.264,123.414s-4.613,2.122-6.517,4.652-.975,9.133-2.517,8.422a3.11,3.11,0,0,1-1.489-1.871,16.323,16.323,0,0,1,1.575-7.394c1.2-2.168,3.631-3.558,6.346-4.3a15.261,15.261,0,0,1,2.6.494Z",
    transform: "translate(-58 -122.873)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95817",
    "data-name": "Path 95817",
    d: "M87.228,140.359c-.152-1.773.9-6.755,2.346-9.74s6.7-5.417,7.473-5.5c1.885-.185,2.438.659,2.708.428s-1.931-2.043-2.511-2.273a6.076,6.076,0,0,0-2.682-.237c-.811.145-5.733,1.43-7.216,3.848s-3.084,8.8-2.425,10.26c.171.349.659.507.929,1.008.316.659.58,1.417.863,1.865S87.241,140.511,87.228,140.359Z",
    transform: "translate(-58.009 -122.896)",
    fill: "#ffc727"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95818",
    "data-name": "Path 95818",
    d: "M91.084,131.787a9.355,9.355,0,0,1-1.318-.7,6.267,6.267,0,0,1-1.213-.949s-.072,0-.046.04a4.989,4.989,0,0,0,1.14,1.094,4.106,4.106,0,0,0,1.443.606.046.046,0,0,0-.007-.092Z",
    transform: "translate(-59.282 -125.335)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95819",
    "data-name": "Path 95819",
    d: "M87.112,145.275c-.072-.119-.171-.217-.25-.329a1.918,1.918,0,0,1-.231-.409,4.026,4.026,0,0,0-.336-.817,3.123,3.123,0,0,0-.5-.521,1.226,1.226,0,0,1-.461-.659H85.28c.079.534.494.857.8,1.265a5.186,5.186,0,0,1,.382.876,1.384,1.384,0,0,0,.58.659C87.072,145.36,87.132,145.321,87.112,145.275Z",
    transform: "translate(-58.184 -129.564)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95820",
    "data-name": "Path 95820",
    d: "M87.458,142.378c-.2-.171-.4-.323-.586-.514a5.812,5.812,0,0,1-.481-.6c-.152-.2-.27-.422-.415-.659s-.362-.468-.521-.725c0,0-.066,0-.046.04.165.257.277.554.428.817a6.53,6.53,0,0,0,.448.659,4.2,4.2,0,0,0,.514.567,1.851,1.851,0,0,0,.659.409S87.471,142.391,87.458,142.378Z",
    transform: "translate(-58.226 -128.657)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95821",
    "data-name": "Path 95821",
    d: "M88,139.866a4.89,4.89,0,0,1-1.12-.929c-.316-.356-.619-.731-.909-1.107h-.046a5.733,5.733,0,0,0,.811,1.239,2.88,2.88,0,0,0,.534.488,4.008,4.008,0,0,0,.679.362S88.037,139.919,88,139.866Z",
    transform: "translate(-58.403 -127.958)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95822",
    "data-name": "Path 95822",
    d: "M88.683,137.2a1.733,1.733,0,0,1-.534-.4q-.277-.257-.534-.534c-.171-.178-.343-.343-.507-.521a1.76,1.76,0,0,1-.415-.593H86.64a1.615,1.615,0,0,0,.31.659,4.614,4.614,0,0,0,.5.659,6.4,6.4,0,0,0,.586.534,1.18,1.18,0,0,0,.626.3.054.054,0,0,0,.02-.105Z",
    transform: "translate(-58.647 -127.047)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95823",
    "data-name": "Path 95823",
    d: "M89.156,134.284q-.29-.2-.554-.415c-.171-.152-.343-.3-.507-.461s-.356-.329-.521-.507c0,0-.066,0-.046.033a4.179,4.179,0,0,0,.428.586,5.194,5.194,0,0,0,.507.5,5.114,5.114,0,0,0,.567.428,1.72,1.72,0,0,0,.659.31.04.04,0,0,0,0-.066A3.638,3.638,0,0,0,89.156,134.284Z",
    transform: "translate(-58.949 -126.277)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95824",
    "data-name": "Path 95824",
    d: "M92.726,129.913a7.793,7.793,0,0,0-.659-.54c-.244-.171-.468-.323-.718-.468a7.441,7.441,0,0,0-1.5-.705s-.059.033,0,.053c.936.58,1.9,1.12,2.84,1.713a.033.033,0,1,0,.04-.053Z",
    transform: "translate(-59.732 -124.674)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95825",
    "data-name": "Path 95825",
    d: "M94.274,127.718a4.059,4.059,0,0,0-.659-.468,7.6,7.6,0,0,0-1.634-.6c-.04,0-.059.04,0,.053.507.231,1.015.455,1.5.712.237.132.481.264.705.415s.415.356.659.521h0a2.109,2.109,0,0,0-.573-.633Z",
    transform: "translate(-60.456 -124.145)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95826",
    "data-name": "Path 95826",
    d: "M96.455,126.348a3.736,3.736,0,0,0-.659-.474,4.487,4.487,0,0,0-1.4-.554s-.046.046,0,.059a8.132,8.132,0,0,1,1.318.659c.211.132.422.277.659.422s.4.329.619.448h0a4.093,4.093,0,0,0-.54-.56Z",
    transform: "translate(-61.287 -123.692)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95827",
    "data-name": "Path 95827",
    d: "M98.238,125a6.827,6.827,0,0,0-.659-.336,2.385,2.385,0,0,0-.659-.25v.059l1.2.705a6.226,6.226,0,0,1,.975.837h0A2.24,2.24,0,0,0,98.238,125Z",
    transform: "translate(-62.153 -123.381)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95828",
    "data-name": "Path 95828",
    d: "M100.17,124.277a3.717,3.717,0,0,0-1.285-.547c-.033,0-.046.046,0,.059a4.415,4.415,0,0,1,1.193.659,6.221,6.221,0,0,1,1,.909h.033A2.978,2.978,0,0,0,100.17,124.277Z",
    transform: "translate(-62.813 -123.149)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95829",
    "data-name": "Path 95829",
    d: "M102.743,124.685a2.288,2.288,0,0,0-.2-.244,3.092,3.092,0,0,0-.461-.415,6.5,6.5,0,0,0-1.114-.606v.053a5.053,5.053,0,0,1,1.054.659,3.8,3.8,0,0,1,.448.409,2.09,2.09,0,0,1,.2.224,1.515,1.515,0,0,0,.185.224h.046A1.054,1.054,0,0,0,102.743,124.685Z",
    transform: "translate(-63.534 -123.044)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95830",
    "data-name": "Path 95830",
    d: "M104.617,124.759a4.724,4.724,0,0,0-.382-.343,3.676,3.676,0,0,0-.422-.29c-.152-.092-.3-.178-.448-.277,0,0-.066.033,0,.053a2.894,2.894,0,0,1,.435.31l.382.316.389.316a3.8,3.8,0,0,0,.389.329h0a2.366,2.366,0,0,0-.343-.415Z",
    transform: "translate(-64.341 -123.19)",
    fill: "#263238"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-57",
    transform: "translate(92.37 67.442)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_95831",
    "data-name": "Path 95831",
    d: "M150.334,98.127a14.32,14.32,0,0,1-23.934,9.061l-7.17,1.054,3.585-6.194a14.326,14.326,0,1,1,27.519-3.954Z",
    transform: "translate(-118.749 -82.186)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95832",
    "data-name": "Path 95832",
    d: "M150.085,98.061a14.412,14.412,0,0,1-2.893,7.249,12.935,12.935,0,0,1-2.807,2.774,13.9,13.9,0,0,1-3.46,1.924,14.379,14.379,0,0,1-3.855.923,15.435,15.435,0,0,1-1.977.04,13.418,13.418,0,0,1-1.977-.211,14.425,14.425,0,0,1-7.084-3.5l.165.053-7.176,1.087-.521.079.264-.455,3.565-6.214v.25a14.5,14.5,0,0,1,.863-12.771,14.682,14.682,0,0,1,4.488-4.778,14.5,14.5,0,0,1,22.405,13.522Zm0,0A14.2,14.2,0,0,0,127.91,84.894a14.787,14.787,0,0,0-4.29,4.679,14.2,14.2,0,0,0-1.819,6.056,14.451,14.451,0,0,0,1.008,6.247l.053.125-.066.119-3.611,6.181-.25-.376,7.17-1.008h.1l.072.066a14.1,14.1,0,0,0,6.86,3.532,12.052,12.052,0,0,0,1.977.237,13.837,13.837,0,0,0,1.977,0,14.122,14.122,0,0,0,3.829-.843,13.265,13.265,0,0,0,3.453-1.865,15.35,15.35,0,0,0,1.516-1.259A16.405,16.405,0,0,0,147.2,105.3,14.4,14.4,0,0,0,150.085,98.061Z",
    transform: "translate(-118.5 -82.12)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95833",
    "data-name": "Path 95833",
    d: "M139.1,108.04l-6.115-6.194,2.056-2.03,3.572,3.618,7.427-11.644,2.438,1.555Z",
    transform: "translate(-123.438 -85.418)",
    fill: "#ffc727"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmedCuate);
export default __webpack_public_path__ + "static/media/Confirmed-cuate.73e04f75d5dbc3708e38aaa46e096c33.svg";
export { ForwardRef as ReactComponent };